/* One contextual shortcut row; filtering still runs through the native Shopify facets. */
if (!customElements.get('adore-collection-quick')) {
  customElements.define('adore-collection-quick', class extends HTMLElement {
    connectedCallback() {
      if (this.controller && !this.controller.signal.aborted) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.addEventListener('click', async event => {
        const link = event.target.closest('[data-quick-value]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
        const facets = document.getElementById('facet-filters');
        if (typeof facets?.applyFilters !== 'function') return;
        event.preventDefault();
        await facets.applyFilters(this.urlFor(link.dataset.quickValue).searchParams.toString(), event);
      }, {signal});
      document.addEventListener('on:facet-filters:updated', () => this.sync(), {signal});
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    urlFor(value) {
      const url = new URL(window.location.href);
      const key = this.dataset.key;
      const selected = key === 'price'
        ? url.searchParams.get('filter.v.price.lte') === value
        : url.searchParams.getAll(key).includes(value);
      if (key === 'price') {
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        if (value && !selected) url.searchParams.set('filter.v.price.lte',value);
      } else {
        url.searchParams.delete(key);
        if (value && !selected) url.searchParams.set(key,value);
      }
      url.searchParams.delete('page');
      url.hash = 'products-toolbar';
      return url;
    }
    sync() {
      const params = new URLSearchParams(window.location.search);
      const key = this.dataset.key;
      const selected = key === 'price' ? [params.get('filter.v.price.lte')].filter(Boolean) : params.getAll(key);
      const fields = [...document.querySelectorAll('#facet-filters input')].filter(input=>input.name === key);
      this.querySelectorAll('[data-quick-value]').forEach(link=>{
        const value=link.dataset.quickValue;
        const active=value ? selected.includes(value) : selected.length===0 && (key!=='price' || !params.get('filter.v.price.gte'));
        if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
        const input=fields.find(input=>input.value===value);
        const unavailable=!!value && key!=='price' && (!input || input.disabled) && !active;
        if(unavailable){link.setAttribute('aria-disabled','true');link.tabIndex=-1;}else{link.removeAttribute('aria-disabled');link.removeAttribute('tabindex');}
        link.href=this.urlFor(value).href;
      });
    }
  });
}
